import { css } from 'styled-components'

export default css`
  &.StreamingAgentPage {
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
`
